import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaChevronRight,
} from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  return (
    <footer id='colophon' itemType='https://schema.org/WPFooter' itemScope role='contentinfo'>
      {/* CTA Section */}
      <section className='footer-cta-section'>
        <div className='container'>
          <div className='cta-content'>
            <div className='cta-text'>
              <h2>Something like</h2>
              <h2 className='highlight'>"Need Help With University Admissions?</h2>
              <p className='cta-description'>
                Need A Consultation?{' '}
                <span className='contact-links'>
                  <a href='tel:+971581236700' className='phone-link'>
                    <FaPhone className='contact-icon' />
                    +971 581236700
                  </a>
                  <span className='separator'>or</span>
                  <a href='mailto:admin@destnation.org' className='email-link'>
                    <FaEnvelope className='contact-icon' />
                    admin@destnation.org
                  </a>
                </span>
              </p>
            </div>
            <div>
              <Link to='/contact-us' className='btn-contact'>
                CONTACT US →
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Main Footer */}
      <section className='main-footer'>
        <div className='container'>
          {/* Footer Logo and Description */}
          <div className='footer-logo-section'>
            <Link to='/' className='footer-logo'>
              <img
                src='/assets/img/logo/logo-white.webp'
                alt='Logo'
                style={{ height: '80px' }}
                className='footer-logo-img'
              />
            </Link>
            <p className='footer-description'>
              Destnation Education is a company that helps students to migrate to other countries
              for their higher education.
            </p>
          </div>

          <div className='footer-divider'></div>

          {/* Footer Columns */}
          <div className='footer-columns'>
            {/* Quick Links */}
            <div className='footer-column'>
              <h4>Quick Links</h4>
              <ul className='footer-links'>
                <li>
                  <Link to='/'>
                    <FaChevronRight className='chevron-icon' />
                    Home
                  </Link>
                </li>
                <li>
                  <Link to='/about-us'>
                    <FaChevronRight className='chevron-icon' />
                    About us
                  </Link>
                </li>
                <li>
                  <Link to='/universities'>
                    <FaChevronRight className='chevron-icon' />
                    Universities
                  </Link>
                </li>
                <li>
                  <Link to='/features'>
                    <FaChevronRight className='chevron-icon' />
                    Features
                  </Link>
                </li>
                <li>
                  <Link to='/contact-us'>
                    <FaChevronRight className='chevron-icon' />
                    Contact Us
                  </Link>
                </li>
              </ul>
            </div>

            {/* Company */}
            <div className='footer-column'>
              <h4>Company</h4>
              <ul className='footer-links'>
                <li>
                  <Link to='/admission'>
                    <FaChevronRight className='chevron-icon' />
                    Admission
                  </Link>
                </li>
                <li>
                  <Link to='/team'>
                    <FaChevronRight className='chevron-icon' />
                    Team
                  </Link>
                </li>
                <li>
                  <Link to='/testimonials'>
                    <FaChevronRight className='chevron-icon' />
                    Testimonials
                  </Link>
                </li>
                <li>
                  <Link to='/gallery'>
                    <FaChevronRight className='chevron-icon' />
                    Gallery
                  </Link>
                </li>
                <li>
                  <Link to='/blogs'>
                    <FaChevronRight className='chevron-icon' />
                    Blogs
                  </Link>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div className='footer-column'>
              <h4>Contact</h4>
              <ul className='footer-contact'>
                <li>
                  <FaMapMarkerAlt className='contact-icon' />
                  <span>Locations : UAE, INDIA, EGYPT, GEORGIA</span>
                </li>
                <li>
                  <a href='tel:+971581236700'>
                    <FaPhone className='contact-icon' />
                    <span>Phone : +971 581236700</span>
                  </a>
                </li>
                <li>
                  <a href='mailto:admin@destnation.org'>
                    <FaEnvelope className='contact-icon' />
                    <span>Email : admin@destnation.org</span>
                  </a>
                </li>
              </ul>

              {/* Social Icons */}
              <div className='social-icons'>
                <a
                  href='https://www.facebook.com/share/1BMrZETK4d/'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='social-icon facebook'
                >
                  <FaFacebookF />
                </a>
                <a
                  href='https://www.instagram.com/destnationeducation?igsh=NXZra3M0anJyZzA5'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='social-icon instagram'
                >
                  <FaInstagram />
                </a>
                <a
                  href='https://www.youtube.com/@DestnationEducation'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='social-icon youtube'
                >
                  <FaYoutube />
                </a>
              </div>
            </div>
          </div>

          <div className='footer-divider'></div>

          {/* Copyright */}
          <div className='footer-copyright'>
            <p>
              Copyright © 2025 Destnation, All rights reserved Website Design And Development –
              First Reach Digital Pvt Ltd
            </p>
          </div>
        </div>
      </section>
    </footer>
  );
};

export default Footer;
